export default __webpack_public_path__ + "static/media/image.henkei-corporation-pvt-ltd.95e0b4fe.png";